<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link :to="{ name: 'EXCMSlaCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #filtering></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.excmsla.list.noSla') }}
      </div>
      <table class="table table-sm table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.excmsla.list.name')}}</th>
          <th colspan="1" />
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item['@id']">
          <td>
            {{ item['title'] }}
          </td>
          <td>
            <router-link :to="{name: 'EXCMSlaUpdate', params: { id: item['@id'] }}">
              <button class="float-right btn btn-link fa fa-edit fa-lg" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
            </router-link>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination
        v-if="view"
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'

export default {
  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  computed: mapGetters({
    deletedItem: 'excmsla/del/deleted',
    error: 'excmsla/list/error',
    items: 'excmsla/list/items',
    isLoading: 'excmsla/list/isLoading',
    view: 'excmsla/list/view'
  }),

  data () {
    return {
      searchParams: {
        '_page': 1,
        'state': 1
      }
    }
  },

  created () {
    // let url = '/api/e_x_c_m_slas?_page=1&state=1'
    let url = addParamsToQuery('e_x_c_m_slas', this.searchParams)
    this.getPage(url)
  },

  methods: mapActions({
    getPage: 'excmsla/list/default'
  })
}
</script>
